document.addEventListener("DOMContentLoaded", function () {
    let ctaSections = document.querySelectorAll(".cta-section-wrap");

    function setWidth(element, totalMoveAmount) {}
    function handleResize() {
        checkIfOffsetBackgroundIsAffixedLeft(
            ctaSections,
            setWidth,
            "marginLeft"
        );
    }

    window.addEventListener("resize", cmpDebounce(handleResize, 500));
    checkIfOffsetBackgroundIsAffixedLeft(ctaSections, setWidth, "marginLeft");
});
